import { environment } from '../environments/environment';

import { IAppConfig } from 'ee-common-lib';

export const CUSTOMER_APP_CONFIG: IAppConfig = {
	apiBaseUrl: environment.apiBaseUrl,
	pageSize: 25,
	maxNumPages: 10
};
